import type { CreateFlowApiArg } from 'lib-shared-types-api';

/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Returns transformed flow by appending deprecated fields expected by the
 * endpoint.
 *
 * @param flow The flow to transform.
 */
export function transformFlowCreateOrUpdate(
  flow: CreateFlowApiArg,
): CreateFlowApiArg {
  return {
    ...flow,
    actions: flow.actions.map(({ wait_music, ...action }: any) => ({
      ...action,
      text: '',
      icon: '',
      isAction: false,
      overlay: [],
      badges: [],
      ...(!!wait_music && { wait_music_v2: wait_music }),
    })),
  };
}
